<template>
  <div
      :class="Object.keys(data).length > 1?'list-group':'single-line'"
  >
    <template
        v-for="(item, i) in data"
    >
      <div
          v-if="item.hide !== true"
          :class="Object.keys(data).length > 1?'list-group-item':''"
      >
        <template v-if="item.format == 'bool'">

        <span
            :class="item.value? 'text-success' : 'text-danger'"
        >
        <i
            v-if="item.value"
            class="bi bi-check-circle-fill text-success"
        />
        <i
            v-else-if="!item.value"
            class="bi bi-x-circle-fill text-danger"
        />

        <span class="ms-2">{{item.title}}</span>        </span>

        </template>

        <template
            v-else-if="item.format == 'price'"
        >
          <span
              v-if="displayTitle"
              class="text-muted me-2"
          >
            {{item.title}}:
          </span>
          <span>
          {{ formatDisplayPrice(item.value, item.sufix) }}
        </span>
        </template>

        <template
            v-else-if="item.format == 'link'"
        >
          <span class="text-muted me-2">{{item.title}}:</span>
          <a
              v-if="item.value"
              :href="(item.definition.link.protocol? item.definition.link.protocol: '') + item.value"
              :class="(item.definition.link.class? item.definition.link.class: ' btn btn-link')"
          >
            {{ (item.definition.link.title? item.definition.link.title: item.value) }}
          </a>
          <span
            v-else
              class="font-monospace fs-6 text-danger"
          >
            <i class="bi bi-x-circle  mx-1"/>
            nejsou zadna data

          </span>
        </template>

        <template
            v-else-if="item.format == 'children'"
        >
          [kids]
        </template>

        <template
            v-else-if="item.format == 'btn_modal'"
        >

          <span class="text-muted me-2">{{item.title}}:</span>

          <div
              class="btn btn-sm btn-outline-primary"
              @click.prevent="openModal(item.value, item.definition.router)"
          >
            <i
                v-if="item.definition.btn.ico"
                :class="item.definition.btn.ico + ' me-1'"
            ></i>
            {{item.definition.btn.title}}
          </div>

        </template>

        <template
            v-else-if="item.format == 'datetime'"
        >
          <span class="text-muted me-2">{{item.title}}:</span>
          {{ formatDisplayDatetime(item.value, $i18n.locale) }}
        </template>

        <template
            v-else-if="item.format == 'date'"
        >
          <span class="text-muted me-2">{{item.title}}:</span>
          {{ formatDisplayDate(item.value, $i18n.locale)}}
        </template>

        <template
            v-else-if="item.format == 'date_range'"
        >
          <span class="text-muted me-2">{{item.title}}:</span>
          {{ formatDisplayRangeDate(item.value, $i18n.locale)}}
        </template>

        <template
            v-else-if="item.format == 'datetime_range'"
        >
          <span class="text-muted me-2">{{item.title}}:</span>
          {{ formatDisplayRangeDatetime(item.value, $i18n.locale)}}
        </template>

        <template
            v-else-if="item.format == 'table'"
        >
          <span class="text-muted me-2">{{item.title}}:</span>

          <table
            class="table table-responsive"
          >
            <thead>
              <tr>
                <template
                    v-for="(headerItem) in item.value[0]"
                >
                  <th
                      v-if="headerItem.hide != true"
                  >
                    <span>{{headerItem.title}}</span>
                  </th>
                </template>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(listRow) in item.value"
            >
              <template
                  v-for="(listItem,x ) in listRow"
              >
                <td
                  v-if="listItem.hide != true"
                >
                  <view-item
                      :data="[listItem]"
                      :display-title="false"
                  />
                </td>
              </template>
            </tr>
            </tbody>
          </table>
        </template>

        <template
            v-else-if="item.format == 'title_from_object'"
        >
          <span
              v-if="displayTitle"
              class="text-muted me-2"
          >
            {{item.title}}:
          </span>

          <template
            v-if="item.value.title"
          >
            {{item.value.title}}
          </template>
        </template>

        <template v-else>
          <span
              v-if="displayTitle"
              class="text-muted me-2"
          >
            {{item.title}}:
          </span>
          <span>




          <template
            v-if="item.value"
          >
            <span v-if="item.prefix" class="me-1"> {{item.prefix}}</span>
            {{item.value}}
            <span v-if="item.sufix" class="ms-1"> {{item.sufix}}</span>
          </template>
          <span
              v-else
              class="font-monospace fs-6 text-danger"
          >
            <i class="bi bi-x-circle  mx-1"/>
          </span>
        </span>

        </template>

        <!--

        <display-debug>
          <template #debugView>ViewGeneral: {{i}} {{item}}</template>
        </display-debug>

        -->
      </div>
    </template>
  </div>
</template>

<script>

import {
  formatDisplayDate,
  formatDisplayDatetime,
  formatDisplayRangeDate,
  formatDisplayRangeDatetime
} from "@/utils/general";

export default {
  name: "viewItem",
  components: {

  },
  props: {
    "data": {
      type: [Object],
      required: false,
      default: null,
    },
    "displayTitle": {
      type: [Boolean],
      required: false,
      default: true,
    },
    "displayValue": {
      type: [Boolean],
      required: false,
      default: true,
    }
  },
  data() {

  },
  mounted() {

  },
  methods: {
    formatDisplayRangeDatetime,
    formatDisplayRangeDate,
    formatDisplayDate,
    formatDisplayDatetime,
    openModal(id,configuration) {
      this.modal.data.submit = false;
      this.modal.data.saved = false;
      this.modal.config.display = true;

      this.modalOpen = {...this.modal};
      this.modalOpen.title = configuration.title;
      this.modalOpen.router.modul = configuration.module;
      this.modalOpen.router.action = this.getRouterAction(configuration.action, id)
    },

    getRouterAction(prefix, id) {
      return prefix + '/' + id + '?lang_code=' + this.$i18n.locale;
    }
  },
  watch: {

  },
};
</script>


